export const formatToThousands = (value) => {
  const number = parseInt(value, 10);
  return number > 1000 ? `${(number / 1000).toFixed(1)}k` : number;
};

export const formatToGroupedThousands = value =>
  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');



// WEBPACK FOOTER //
// ./src/universal/ui/utils/number.js